/**
 * 이름 마스킹 처리
 * @param name 마스킹할 이름
 * @returns 마스킹된 이름 (예: 홍*동, 장**호, 김*)
 * @note 정책: 이름이 2글자 이상일 경우 첫 글자와 마지막 글자는 보이고 나머지는 * 마스킹 / 2글자인 경우 첫 글자만 보이고 나머지는 * 마스킹 / 1글자인 경우 그대로 보임
 */
const maskName = (name: string | null | undefined): string => {
  if (!name) return '-';

  const length = name.length;

  if (length === 1) return name;
  if (length === 2) return `${name[0]}*`;

  return `${name[0]}${'*'.repeat(length - 2)}${name[length - 1]}`;
};

export default maskName;
